module.exports = __webpack_public_path__ + "img/800x400.c0763e46.svg";